export default "__VITE_ASSET__Mc29WES8__"